import { render, staticRenderFns } from "./TabelaSaldoInvestir.vue?vue&type=template&id=1ff8508e&"
import script from "./TabelaSaldoInvestir.vue?vue&type=script&lang=js&"
export * from "./TabelaSaldoInvestir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports